/**
 * Каталог на всички възможни колони в /cases списъка. UI компонентите
 * (cases.component, preferences.component) ползват този enum като
 * единствен източник на истина — нов column = един ред тук.
 */
export interface CaseColumnDef {
	name: string;
	title: string;
	dataType?: string;
	complexDataType?: any;
}

export const CASE_COLUMNS_CATALOG: CaseColumnDef[] = [
	// Идентификатори
	{ name: 'caseNumber', title: 'Гр. дело номер' },
	{ name: 'damageNumber', title: 'Щета номер' },
	{ name: 'claimNumber', title: 'Вх. № претенция' },
	{ name: 'applicationNumber', title: 'Вх. № искова молба' },
	{
		name: 'izpulnitelnoDelo', title: 'Изпълнително дело',
		dataType: 'object', complexDataType: { object: true, displayValue: 'number' }
	},
	{
		name: 'nakazatelnoDelo', title: 'Наказателно Дело',
		dataType: 'object', complexDataType: { object: true, displayValue: 'number' }
	},
	{
		name: 'nakazatelnoDelo_prokusrorska', title: 'Прокурорска преписка',
		dataType: 'object', complexDataType: { object: true, displayValue: 'prokusrorskaPrepiskaNomer' }
	},
	{
		name: 'nakazatelnoDelo_zmMvr', title: 'ЗМ-МВР',
		dataType: 'object', complexDataType: { object: true, displayValue: 'zmMvrNomer' }
	},

	// Класификация
	{
		name: 'vidSluchaj', title: 'Вид случай',
		dataType: 'object', complexDataType: { object: true, displayValue: 'name' }
	},
	{
		name: 'traumaType', title: 'Тип Травма',
		dataType: 'object', complexDataType: { object: true, displayValue: 'name' }
	},
	{
		name: 'damageType', title: 'Вид щета',
		dataType: 'object', complexDataType: { object: true, displayValue: 'name' }
	},
	{ name: 'traumas', title: 'Травми (текст)' },

	// Списъци от лица — рендерират се през 'list' dataType
	{
		name: 'claimentList', title: 'Ищци',
		dataType: 'list', complexDataType: { displayValue: 'name' }
	},
	{
		name: 'defendantList', title: 'Ответници',
		dataType: 'list', complexDataType: { displayValue: 'name' }
	},

	// Дати + място
	{ name: 'date', title: 'Дата ПТП' },
	{ name: 'mjastoPTP', title: 'Място ПТП' },
	{ name: 'claimDate', title: 'Дата претенция' },

	// Суми
	{ name: 'claimCost', title: 'Сума претенция', dataType: 'currency' },
	{ name: 'cost', title: 'Цена на иска', dataType: 'currency' },
	{ name: 'costProperty', title: 'Цена иска (имущ.)', dataType: 'currency' },
	{ name: 'chastichenIsk', title: 'Частичен иск', dataType: 'currency' },

	// Отговорници
	{
		name: 'lawyer', title: 'Адвокат',
		dataType: 'object', complexDataType: { object: true, displayValue: 'names' }
	},
	{
		name: 'claimResponsible', title: 'Отг. претенция',
		dataType: 'object', complexDataType: { object: true, displayValue: 'names' }
	},
	{ name: 'mediator', title: 'Посредник' },
	{ name: 'percentage', title: 'Процент' }
];

/** Имената по подразбиране — стандартният минимален набор колони.
 *  Останалите потребителят може да включи от Preferences. */
export const DEFAULT_VISIBLE_COLUMN_NAMES: string[] = [
	'caseNumber',
	'damageNumber',
	'izpulnitelnoDelo',
	'nakazatelnoDelo',
	'nakazatelnoDelo_prokusrorska',
	'nakazatelnoDelo_zmMvr',
	'traumaType',
	'cost'
];
